import { CollisionSystem, ModelLoadedEventSystem, PlannerCoreApi, SelectionEventSystem, MeasurementsWidgetSystem, HighlightAddedEntitySystem, UnavailableProductsEventSystem, HistoryEventSystem, InvalidFramePlacementSystem, HistoryApi, InteractableFrameSystem, OutlineSelectedFrameSystem, ConflictSystem, ConflictOutlineSystem, FrameDragAdaptAdjustableClothRailSystem, AdaptAdjustableSystem, ExpandClothRailSystem, FrameDragValidation } from '@inter-ikea-storageone/range';
import { AlignmentConnectionCreationSystem, OutlineSystem } from '@inter-ikea-core/core';
import { FunctionalMarginSystem, FunctionalMarginValidation, PlacementZoneValidation, RequiredConnectorsSatisfiedValidation } from '@inter-ikea-core/core';
import { AurdalCameraApi } from './AurdalCameraApi';
import { AurdalEntityApi } from './AurdalEntityApi';
import { AurdalProductApi } from './AurdalProductApi';
import { AurdalSceneApi } from './AurdalSceneApi';
import Aurdal from '@inter-ikea-storagetwo/aurdal/dist';
import { SimpleOutlineSelectedSystem } from '@inter-ikea-core/core-toolbox';
import { AdjustableClothRailValidation } from './validation/AdjustableClothRailValidation';
import RemoveClothRailBoundsOnFrameDragSystem from '@inter-ikea-storageone/range/src/core-api/systems/RemoveClothRailBoundsOnFrameDragSystem';
import RemoveClothRailWhenRemovingFrameSystem from '@inter-ikea-storageone/range/src/core-api/systems/RemoveClothRailWhenRemovingFrameSystem';
export class AurdalCoreApi extends PlannerCoreApi {
    constructor() {
        super(...arguments);
        this.AurdalApi = new Aurdal({ core: this.core });
    }
    bootstrap(config) {
        if (!this.core) {
            throw new Error('Core not initialized yet');
        }
        // Setup core base functionality
        const { selectionService, placementService } = super.initializeBaseCoreFunctionality();
        // Register core systems
        this.registerSystem(new FunctionalMarginSystem());
        // Register core validations
        this.registerValidation(new PlacementZoneValidation());
        this.registerValidation(new FunctionalMarginValidation(false, this.core.services.entityManager));
        this.registerValidation(new RequiredConnectorsSatisfiedValidation());
        // Setup plannner APIs
        this.products = new AurdalProductApi(this.core.services, placementService, this.reportErrorToSentry);
        this.entities = new AurdalEntityApi(selectionService, this.core, placementService, this.ipexViewer, this.reportErrorToSentry);
        this.registerValidation(new AdjustableClothRailValidation(this));
        this.registerValidation(new FrameDragValidation(this));
        // Register planner systems
        this.registerSystem(new CollisionSystem(this, []));
        this.registerSystem(new OutlineSystem());
        this.registerSystem(new SimpleOutlineSelectedSystem());
        this.registerSystem(new ModelLoadedEventSystem(this));
        this.registerSystem(new UnavailableProductsEventSystem(this));
        this.registerSystem(new AlignmentConnectionCreationSystem(this.getServices()));
        this.registerSystem(new InvalidFramePlacementSystem(this));
        this.registerSystem(new SelectionEventSystem(this));
        this.registerSystem(new OutlineSelectedFrameSystem(this));
        this.registerSystem(new HistoryEventSystem(this));
        this.registerSystem(new MeasurementsWidgetSystem(this));
        this.registerSystem(new HighlightAddedEntitySystem(this));
        this.registerSystem(new ConflictSystem(this));
        this.registerSystem(new ConflictOutlineSystem(this));
        this.registerSystem(new InteractableFrameSystem(this));
        this.registerSystem(new AdaptAdjustableSystem(this));
        this.registerSystem(new RemoveClothRailBoundsOnFrameDragSystem(this));
        this.registerSystem(new FrameDragAdaptAdjustableClothRailSystem(this));
        this.registerSystem(new ExpandClothRailSystem(this));
        this.registerSystem(new RemoveClothRailWhenRemovingFrameSystem(this));
        return this.loadProductCatalogs(config.productCatalogs);
    }
    getMainProductCatalog() {
        return this.catalogs['aurdal'];
    }
    initSceneApi() {
        this.scene = new AurdalSceneApi(this.core, this.ipexViewer, this.reportErrorToSentry);
    }
    initCameraApi(canvas) {
        this.camera = new AurdalCameraApi(this.core.services.sceneManager, this.ipexViewer, this.core.services.entityManager, this, canvas);
    }
    /**
     * @override
     */
    createViewer(canvas, renderSettings, applicationName, locale, dexfBaseUrl, dexfApiKey, isProduction, enableFeatures, roomOptions) {
        const viewer = super.createViewer(canvas, renderSettings, applicationName, locale, dexfBaseUrl, dexfApiKey, isProduction, enableFeatures, roomOptions);
        if (!this.AurdalApi)
            throw new Error('Not able to register viewer.');
        this.AurdalApi.init({
            viewer: this.ipexViewer,
            viewerCoreAdapter: this.viewer
        });
        return viewer;
    }
    /**
     * @override
     */
    async loadCatalog(productCatalog) {
        if (productCatalog.name === 'aurdal') {
            this.history = new HistoryApi(this);
            this.catalogs['aurdal'] = this.AurdalApi.setupCatalog();
        }
        else {
            await super.loadCatalog(productCatalog);
        }
    }
}
//# sourceMappingURL=AurdalCoreApi.js.map